import { NivosLayout } from 'types/layout'

const Types = {
  SET: '@@layout/SET',
  UPDATE: '@@layout/UPDATE'
}

export type Payload = NivosLayout

export { Types }
